var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"my-3 base-body-text"},[_vm._v(_vm._s(_vm.designation))])
}
var staticRenderFns = []

export { render, staticRenderFns }